// Forgr homepage: cost-out calculator
(function () {
  if (!document.getElementById("f-price")) return;
  const $ = id => document.getElementById(id);
  const num = id => { const v = parseFloat(String($(id).value).replace(/[^0-9.]/g, "")); return isFinite(v) ? v : 0; };
  const money = n => (n < 0 ? "−$" : "$") + Math.abs(n).toFixed(2);
  const moneyBig = n => (n < 0 ? "−$" : "$") + Math.abs(n).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

  function set(id, text) {
    const el = $(id);
    if (el.textContent !== text) {
      el.textContent = text;
      el.classList.remove("flash"); void el.offsetWidth; el.classList.add("flash");
    }
  }

  function calc() {
    const price = num("f-price"), ingr = num("f-ingr"), pack = num("f-pack");
    const cardPct = num("f-card"), booth = num("f-booth"), units = Math.max(0, Math.round(num("f-units")));
    const card = price * cardPct / 100;
    const boothPer = units > 0 ? booth / units : 0;
    const trueCost = ingr + pack + card + boothPer;
    const keep = price - trueCost;
    const guess = price - ingr;
    const gap = guess - keep;

    set("o-ingr", money(ingr));
    set("o-pack", money(pack));
    set("o-card", money(card));
    set("o-booth", money(boothPer));
    set("o-true", money(trueCost));
    set("o-guess", money(guess));
    set("o-keep", money(keep));

    const line = $("o-line");
    if (keep <= 0) {
      line.innerHTML = "At these numbers you <strong>lose " + money(-keep) + " on every taco</strong>. Selling more makes it worse.";
    } else if (units > 0) {
      line.innerHTML = "That's <strong>" + money(gap) + " a taco</strong> you thought you had. Over " + units.toLocaleString("en-US") +
        " tacos, <strong>" + moneyBig(gap * units) + " a market day</strong>. And you haven't paid yourself yet.";
    } else {
      line.innerHTML = "That's <strong>" + money(gap) + " a taco</strong> you thought you had, and you haven't paid yourself yet.";
    }
  }
  document.querySelectorAll(".costout input").forEach(i => i.addEventListener("input", calc));
  calc();
})();
